import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6eccaed6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "UserManageViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "学生列表", -1));
const _hoisted_3 = {
  class: "ml12"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://sjxzc.oss-cn-beijing.aliyuncs.com/2025/07/18/110a71f4-fd40-4d1c-8acd-0e859c44e7c5.xlsx",
  target: "_blank",
  style: {
    "text-decoration": "none"
  },
  class: "flex items-center justify-center mr12"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "ft12"
}, "下载导入模板")], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "lightcoral"
  },
  class: "ft12 ptr mr12"
}, "删除组&用户", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "lightcoral"
  },
  class: "ft12 ptr"
}, "删除组", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "wbg flex flex-col wd100",
      style: {
        "height": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_LeftGroupList, {
        data: $data.groups,
        onChoose: $options.onChoose
      }, null, 8, ["data", "onChoose"]), _createVNode(_component_el_row, {
        class: "pd12"
      }, {
        default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
          "btn-id": 4,
          "btn-name": "+ 新增分组",
          style: 1,
          size: "small",
          onFresh: $options.init
        }, null, 8, ["onFresh"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "opd12 flex flex-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "pd12 wbg flex items-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 20,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
            "btn-id": 3,
            "btn-name": "添加用户",
            "bind-id": $data.groupId,
            onFresh: _cache[0] || (_cache[0] = $event => _ctx.$refs.studentTable.fetchData())
          }, null, 8, ["bind-id"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_ButtonDialog, {
            "btn-id": 13,
            "btn-name": "导入用户",
            "bind-id": $data.groupId,
            onFresh: _cache[1] || (_cache[1] = $event => _ctx.$refs.studentTable.fetchData())
          }, null, 8, ["bind-id"])]), _createVNode(_component_el_input, {
            placeholder: "输入姓名、手机号搜索用户",
            modelValue: $data.search,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.search = $event),
            class: "ml16",
            style: {
              "width": "300px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [_hoisted_4, $data.groupId != null && $data.groupId > 0 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 0,
            title: "删除组且用户一起删除，确定吗",
            onConfirm: _cache[3] || (_cache[3] = $event => $options.deleteGroup(false))
          }, {
            reference: _withCtx(() => [_hoisted_5]),
            _: 1
          })) : _createCommentVNode("", true), $data.groupId != null && $data.groupId > 0 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 1,
            title: "删除仅将用户从组内踢出，仍然可以在全部内找到，确定删除吗",
            onConfirm: _cache[4] || (_cache[4] = $event => $options.deleteGroup(true))
          }, {
            reference: _withCtx(() => [_hoisted_6]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "pd12 wbg"
      }, {
        default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
          "table-id": 1,
          "max-page-cnt": "5",
          "init-query": {
            'groupId': $data.groupId,
            'search': $data.search
          },
          ref: "studentTable"
        }, {
          operate: _withCtx(data => [_createVNode(_component_el_row, {
            class: "flex items-center justify-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 6,
              class: "flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
                "btn-id": 14,
                "bind-id": data.rowId,
                "init-data": {
                  userId: data.rowId
                },
                "btn-name": "设置",
                size: "small"
              }, null, 8, ["bind-id", "init-data"])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 6,
              class: "flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
                "btn-id": 20,
                "bind-id": data.rowId,
                "init-data": {
                  userId: data.rowId
                },
                "btn-name": "账户",
                size: "small"
              }, null, 8, ["bind-id", "init-data"])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 6,
              class: "flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
                "btn-id": 1,
                "bind-id": data.rowId,
                "init-data": {
                  userId: data.rowId
                },
                "btn-name": "配置次数",
                size: "small"
              }, null, 8, ["bind-id", "init-data"])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 6,
              class: "flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
                "bind-id": data.rowId,
                "btn-id": 2,
                "init-data": {
                  userId: data.rowId
                },
                onFresh: _cache[5] || (_cache[5] = $event => _ctx.$refs.studentTable.fetchData()),
                "btn-name": "组管理",
                size: "small",
                class: "mr16"
              }, null, 8, ["bind-id", "init-data"])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 6,
              class: "flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_popconfirm, {
                title: "确定删除吗",
                onConfirm: $event => $options.deleteUser(data.rowId)
              }, {
                reference: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "danger",
                  size: "small"
                }, {
                  default: _withCtx(() => [_createTextVNode("删除")]),
                  _: 1
                })]),
                _: 2
              }, 1032, ["onConfirm"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          practiceState: _withCtx(data => [data.rowData == 'CLASS_ON' ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.mapping[data.rowData]), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "info"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.mapping[data.rowData]), 1)]),
            _: 2
          }, 1024))]),
          _: 1
        }, 8, ["init-query"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}